import TransactionWelCard from "src/components/transactionWelCard/TransactionWelCard";
import styles from "./reports.module.scss";
import Table from "rc-table";
import { Button, TablePagination } from "@mui/material";
import CircularLoader from "src/components/UI/circularLoader/CircularLoader";
import { useAppDispatch, useAppSelector } from "../store";
import columns from "./reportsConfig";
import { Suspense, lazy, useCallback, useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { LIMIT, PAGE } from "src/components/constant/queryConstants";
import Modalui from "src/components/UI/modal/Modalui";
import { FilterTagType, generateFilterTags } from "src/components/UI/filterTag/filterTagUtils";
import FilterTag from "src/components/UI/filterTag/FilterTag";
import { setColumnFilter, setNovattiFilter } from "../filtersSlice";
import TableColumnFilter from "src/components/UI/tableColumnFIlter/TableColumnFilter";
import { fetchReportsAction } from "./reportsSlice";
const ReportsFilter = lazy(() => import("src/components/reportsModal/reportsFilter/ReportsFilter"));

export default function Reports() {
  const dispatch = useAppDispatch();
  const { reports, loading } = useAppSelector((state) => state.reports);
  const { reports: reportsFilter, column: columnFilter } = useAppSelector((state) => state.filters);
  const [searchParams, setSearchParams] = useSearchParams();
  const [openFilterCard, setOpenFilterCard] = useState<boolean>(false);
  const limit = searchParams.get(LIMIT) ?? "10";
  const page = searchParams.get(PAGE) ?? "0";

  const memoizedFilter = useMemo(() => {
    return JSON.stringify(reportsFilter);
  }, [reportsFilter]);

  const resetPagination = async () => {
    searchParams.delete(PAGE);
    searchParams.delete(LIMIT);
    setSearchParams(searchParams);
  };

  const fetchNovattiTransaction = useCallback(() => {
    const filter: any = {
      report_filter: {}
    };

    if (reportsFilter.startDate) {
      filter.report_filter.report_date = {
        ...(filter.report_filter.report_date || {}),
        min: reportsFilter.startDate
      };
    }
    if (reportsFilter.endDate) {
      filter.report_filter.report_date = {
        ...(filter.report_filter.report_date || {}),
        max: reportsFilter.endDate
      };
    }
    const data = {
      size: Number(limit),
      from: Number(limit) * Number(page),
      filter
      // fileTypes: ["NOVATTI_DAILY_TRANSACTION"]
    };

    dispatch(fetchReportsAction(data));
  }, [reportsFilter, limit, page, dispatch]);

  useEffect(() => {
    fetchNovattiTransaction();
  }, [fetchNovattiTransaction]);

  useEffect(() => {
    if (searchParams.has(PAGE) || searchParams.has(LIMIT)) {
      resetPagination();
    }
  }, [memoizedFilter]);

  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    searchParams.set(PAGE, String(newPage));
    setSearchParams(searchParams);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<{ value: unknown }>) => {
    searchParams.set(LIMIT, event.target.value as string);
    searchParams.delete(PAGE);
    setSearchParams(searchParams);
  };

  const removeTransactionFilter = (filterName: string) => {
    let newFilters;

    if (filterName === "date") {
      newFilters = {
        ...reportsFilter,
        startDate: null,
        endDate: null
      };
    } else {
      newFilters = { ...reportsFilter, [filterName]: null };
    }

    dispatch(setNovattiFilter(newFilters));
  };

  const filteredColumns = useMemo(() => {
    return columns.filter((col) => columnFilter?.reports?.includes(col.key));
  }, [columnFilter?.reports]);

  const handleColumnSelection = (selectedColumns: string[]) => {
    dispatch(
      setColumnFilter({
        reports: selectedColumns
      })
    );
  };

  return (
    <>
      <Modalui open={openFilterCard} handleClose={() => setOpenFilterCard(false)} modaluiOver={styles.filterModalOver}>
        <Suspense fallback={<CircularLoader />}>
          <ReportsFilter handleClose={() => setOpenFilterCard(false)} />
        </Suspense>
      </Modalui>
      <div className={styles.fileWrapper}>
        <div className={styles.WelCard}>
          <TransactionWelCard heading={"View Your Reports"} subHeading={"View details of all the Reports"} />
        </div>
        <div className={styles.fileList}>
          <div className={styles.fileListHead}>
            <div className={styles.fileListHeadIn}>
              <div className={styles.fileListHeadD}>
                <h3>Report list</h3>
                <p>Manage all the Reports</p>
              </div>
              <div className={styles.fileListHeadBtn}>
                <Button variant="outlined" className={styles.clearFilter} onClick={() => setOpenFilterCard(true)}>
                  Filter Report
                </Button>
              </div>
            </div>
            <div className={styles.cardListFilter}>
              <div className={styles.filterTagsContainer}>
                {generateFilterTags(reportsFilter).map((filterTag: FilterTagType) => (
                  <FilterTag
                    key={filterTag.key}
                    tagKey={filterTag.key}
                    label={filterTag.label}
                    onRemove={() => removeTransactionFilter(filterTag.key)}
                  />
                ))}
              </div>
              <TableColumnFilter
                columns={columns}
                selectedColumn={columnFilter?.reports}
                mandatoryColumns={["report_id", "operation"]}
                onApply={handleColumnSelection}
                iconContanerClass={styles.tableColumnContainer}
              />
            </div>
          </div>
          <div className={styles.fileListTable}>
            <Table
              columns={filteredColumns}
              data={loading ? [] : reports.list}
              className={styles.tableIn}
              rowKey="id"
              components={
                loading
                  ? {
                      body: {
                        cell: CircularLoader
                      }
                    }
                  : undefined
              }
            />
          </div>
          <div className={styles.paginationWrapper}>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50, 100]}
              component="div"
              count={reports.size ?? 0}
              page={parseInt(page)}
              onPageChange={handleChangePage}
              rowsPerPage={parseInt(limit)}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </div>
        </div>
      </div>
    </>
  );
}
